var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleFuelType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6L17 6V4L6 4V6Z",
    fill: "#0052BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10L6 10V8L17 8V10Z",
    fill: "#0052BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14L17 14V12L6 12V14Z",
    fill: "#0052BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 18.0001V30H32V32H0V30H2V4C2 1.79086 3.79086 0 6 0H17C19.2091 0 21 1.79086 21 4V16.0001H21.5C23.1569 16.0001 24.5 17.3432 24.5 19.0001V22.2501C24.5 23.2166 25.2835 24.0001 26.25 24.0001C27.2165 24.0001 28 23.2166 28 22.2501V12.8293C27.6872 12.9398 27.3506 13 27 13C25.3431 13 24 11.6569 24 10C24 8.34315 25.3431 7 27 7C27.0952 7 27.1894 7.00444 27.2823 7.01311C26.6771 5.73016 25.7112 4.62388 24.47 3.8481L25.53 2.1521C28.1692 3.8016 29.8252 6.63106 29.9869 9.71833C29.9956 9.81106 30 9.90501 30 10C30 10.0262 29.9997 10.0524 29.999 10.0785C29.9997 10.1246 30 10.1708 30 10.2171V22.2501C30 24.3212 28.3211 26.0001 26.25 26.0001C24.1789 26.0001 22.5 24.3212 22.5 22.2501V19.0001C22.5 18.4478 22.0523 18.0001 21.5 18.0001H21ZM6 2H17C18.1046 2 19 2.89543 19 4V30H4V4C4 2.89543 4.89543 2 6 2ZM27.9983 10.0583C27.997 9.99695 27.995 9.9357 27.9922 9.87457C27.9305 9.38149 27.5098 9 27 9C26.4477 9 26 9.44772 26 10C26 10.5523 26.4477 11 27 11C27.5327 11 27.9681 10.5835 27.9983 10.0583Z",
    fill: "#0052BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleFuelType);
export default __webpack_public_path__ + "static/media/vehicle-fuel-type.a1dd2f3004ebaf64f5c8bc1b160cf78c.svg";
export { ForwardRef as ReactComponent };